import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.typed-array.sort.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as strings from '../../../../base/common/strings.js';
import * as stringBuilder from '../../core/stringBuilder.js';
import { Range } from '../../core/range.js';
export var RichEditBracket = /*#__PURE__*/function () {
  function RichEditBracket(languageIdentifier, index, open, close, forwardRegex, reversedRegex) {
    _classCallCheck(this, RichEditBracket);

    this.languageIdentifier = languageIdentifier;
    this.index = index;
    this.open = open;
    this.close = close;
    this.forwardRegex = forwardRegex;
    this.reversedRegex = reversedRegex;
    this._openSet = RichEditBracket._toSet(this.open);
    this._closeSet = RichEditBracket._toSet(this.close);
  }

  _createClass(RichEditBracket, [{
    key: "isOpen",
    value: function isOpen(text) {
      return this._openSet.has(text);
    }
  }, {
    key: "isClose",
    value: function isClose(text) {
      return this._closeSet.has(text);
    }
  }], [{
    key: "_toSet",
    value: function _toSet(arr) {
      var result = new Set();

      var _iterator = _createForOfIteratorHelper(arr),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;
          result.add(element);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return result;
    }
  }]);

  return RichEditBracket;
}();

function groupFuzzyBrackets(brackets) {
  var N = brackets.length;
  brackets = brackets.map(function (b) {
    return [b[0].toLowerCase(), b[1].toLowerCase()];
  });
  var group = [];

  for (var i = 0; i < N; i++) {
    group[i] = i;
  }

  var areOverlapping = function areOverlapping(a, b) {
    var _a = _slicedToArray(a, 2),
        aOpen = _a[0],
        aClose = _a[1];

    var _b = _slicedToArray(b, 2),
        bOpen = _b[0],
        bClose = _b[1];

    return aOpen === bOpen || aOpen === bClose || aClose === bOpen || aClose === bClose;
  };

  var mergeGroups = function mergeGroups(g1, g2) {
    var newG = Math.min(g1, g2);
    var oldG = Math.max(g1, g2);

    for (var _i = 0; _i < N; _i++) {
      if (group[_i] === oldG) {
        group[_i] = newG;
      }
    }
  }; // group together brackets that have the same open or the same close sequence


  for (var _i2 = 0; _i2 < N; _i2++) {
    var a = brackets[_i2];

    for (var j = _i2 + 1; j < N; j++) {
      var b = brackets[j];

      if (areOverlapping(a, b)) {
        mergeGroups(group[_i2], group[j]);
      }
    }
  }

  var result = [];

  for (var g = 0; g < N; g++) {
    var currentOpen = [];
    var currentClose = [];

    for (var _i3 = 0; _i3 < N; _i3++) {
      if (group[_i3] === g) {
        var _brackets$_i = _slicedToArray(brackets[_i3], 2),
            open = _brackets$_i[0],
            close = _brackets$_i[1];

        currentOpen.push(open);
        currentClose.push(close);
      }
    }

    if (currentOpen.length > 0) {
      result.push({
        open: currentOpen,
        close: currentClose
      });
    }
  }

  return result;
}

export var RichEditBrackets = function RichEditBrackets(languageIdentifier, _brackets) {
  _classCallCheck(this, RichEditBrackets);

  var brackets = groupFuzzyBrackets(_brackets);
  this.brackets = brackets.map(function (b, index) {
    return new RichEditBracket(languageIdentifier, index, b.open, b.close, getRegexForBracketPair(b.open, b.close, brackets, index), getReversedRegexForBracketPair(b.open, b.close, brackets, index));
  });
  this.forwardRegex = getRegexForBrackets(this.brackets);
  this.reversedRegex = getReversedRegexForBrackets(this.brackets);
  this.textIsBracket = {};
  this.textIsOpenBracket = {};
  this.maxBracketLength = 0;

  var _iterator2 = _createForOfIteratorHelper(this.brackets),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var bracket = _step2.value;

      var _iterator3 = _createForOfIteratorHelper(bracket.open),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var open = _step3.value;
          this.textIsBracket[open] = bracket;
          this.textIsOpenBracket[open] = true;
          this.maxBracketLength = Math.max(this.maxBracketLength, open.length);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var _iterator4 = _createForOfIteratorHelper(bracket.close),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var close = _step4.value;
          this.textIsBracket[close] = bracket;
          this.textIsOpenBracket[close] = false;
          this.maxBracketLength = Math.max(this.maxBracketLength, close.length);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};

function collectSuperstrings(str, brackets, currentIndex, dest) {
  for (var i = 0, len = brackets.length; i < len; i++) {
    if (i === currentIndex) {
      continue;
    }

    var bracket = brackets[i];

    var _iterator5 = _createForOfIteratorHelper(bracket.open),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var open = _step5.value;

        if (open.indexOf(str) >= 0) {
          dest.push(open);
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }

    var _iterator6 = _createForOfIteratorHelper(bracket.close),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var close = _step6.value;

        if (close.indexOf(str) >= 0) {
          dest.push(close);
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }
}

function lengthcmp(a, b) {
  return a.length - b.length;
}

function unique(arr) {
  if (arr.length <= 1) {
    return arr;
  }

  var result = [];
  var seen = new Set();

  var _iterator7 = _createForOfIteratorHelper(arr),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var element = _step7.value;

      if (seen.has(element)) {
        continue;
      }

      result.push(element);
      seen.add(element);
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return result;
}

function getRegexForBracketPair(open, close, brackets, currentIndex) {
  // search in all brackets for other brackets that are a superstring of these brackets
  var pieces = [];
  pieces = pieces.concat(open);
  pieces = pieces.concat(close);

  for (var i = 0, len = pieces.length; i < len; i++) {
    collectSuperstrings(pieces[i], brackets, currentIndex, pieces);
  }

  pieces = unique(pieces);
  pieces.sort(lengthcmp);
  pieces.reverse();
  return createBracketOrRegExp(pieces);
}

function getReversedRegexForBracketPair(open, close, brackets, currentIndex) {
  // search in all brackets for other brackets that are a superstring of these brackets
  var pieces = [];
  pieces = pieces.concat(open);
  pieces = pieces.concat(close);

  for (var i = 0, len = pieces.length; i < len; i++) {
    collectSuperstrings(pieces[i], brackets, currentIndex, pieces);
  }

  pieces = unique(pieces);
  pieces.sort(lengthcmp);
  pieces.reverse();
  return createBracketOrRegExp(pieces.map(toReversedString));
}

function getRegexForBrackets(brackets) {
  var pieces = [];

  var _iterator8 = _createForOfIteratorHelper(brackets),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var bracket = _step8.value;

      var _iterator9 = _createForOfIteratorHelper(bracket.open),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var open = _step9.value;
          pieces.push(open);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      var _iterator10 = _createForOfIteratorHelper(bracket.close),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var close = _step10.value;
          pieces.push(close);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }

  pieces = unique(pieces);
  return createBracketOrRegExp(pieces);
}

function getReversedRegexForBrackets(brackets) {
  var pieces = [];

  var _iterator11 = _createForOfIteratorHelper(brackets),
      _step11;

  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var bracket = _step11.value;

      var _iterator12 = _createForOfIteratorHelper(bracket.open),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var open = _step12.value;
          pieces.push(open);
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }

      var _iterator13 = _createForOfIteratorHelper(bracket.close),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var close = _step13.value;
          pieces.push(close);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }

  pieces = unique(pieces);
  return createBracketOrRegExp(pieces.map(toReversedString));
}

function prepareBracketForRegExp(str) {
  // This bracket pair uses letters like e.g. "begin" - "end"
  var insertWordBoundaries = /^[\w ]+$/.test(str);
  str = strings.escapeRegExpCharacters(str);
  return insertWordBoundaries ? "\\b".concat(str, "\\b") : str;
}

function createBracketOrRegExp(pieces) {
  var regexStr = "(".concat(pieces.map(prepareBracketForRegExp).join(')|('), ")");
  return strings.createRegExp(regexStr, true);
}

var toReversedString = function () {
  function reverse(str) {
    if (stringBuilder.hasTextDecoder) {
      // create a Uint16Array and then use a TextDecoder to create a string
      var arr = new Uint16Array(str.length);
      var offset = 0;

      for (var i = str.length - 1; i >= 0; i--) {
        arr[offset++] = str.charCodeAt(i);
      }

      return stringBuilder.getPlatformTextDecoder().decode(arr);
    } else {
      var result = [],
          resultLen = 0;

      for (var _i4 = str.length - 1; _i4 >= 0; _i4--) {
        result[resultLen++] = str.charAt(_i4);
      }

      return result.join('');
    }
  }

  var lastInput = null;
  var lastOutput = null;
  return function toReversedString(str) {
    if (lastInput !== str) {
      lastInput = str;
      lastOutput = reverse(lastInput);
    }

    return lastOutput;
  };
}();

export var BracketsUtils = /*#__PURE__*/function () {
  function BracketsUtils() {
    _classCallCheck(this, BracketsUtils);
  }

  _createClass(BracketsUtils, null, [{
    key: "_findPrevBracketInText",
    value: function _findPrevBracketInText(reversedBracketRegex, lineNumber, reversedText, offset) {
      var m = reversedText.match(reversedBracketRegex);

      if (!m) {
        return null;
      }

      var matchOffset = reversedText.length - (m.index || 0);
      var matchLength = m[0].length;
      var absoluteMatchOffset = offset + matchOffset;
      return new Range(lineNumber, absoluteMatchOffset - matchLength + 1, lineNumber, absoluteMatchOffset + 1);
    }
  }, {
    key: "findPrevBracketInRange",
    value: function findPrevBracketInRange(reversedBracketRegex, lineNumber, lineText, startOffset, endOffset) {
      // Because JS does not support backwards regex search, we search forwards in a reversed string with a reversed regex ;)
      var reversedLineText = toReversedString(lineText);
      var reversedSubstr = reversedLineText.substring(lineText.length - endOffset, lineText.length - startOffset);
      return this._findPrevBracketInText(reversedBracketRegex, lineNumber, reversedSubstr, startOffset);
    }
  }, {
    key: "findNextBracketInText",
    value: function findNextBracketInText(bracketRegex, lineNumber, text, offset) {
      var m = text.match(bracketRegex);

      if (!m) {
        return null;
      }

      var matchOffset = m.index || 0;
      var matchLength = m[0].length;

      if (matchLength === 0) {
        return null;
      }

      var absoluteMatchOffset = offset + matchOffset;
      return new Range(lineNumber, absoluteMatchOffset + 1, lineNumber, absoluteMatchOffset + 1 + matchLength);
    }
  }, {
    key: "findNextBracketInRange",
    value: function findNextBracketInRange(bracketRegex, lineNumber, lineText, startOffset, endOffset) {
      var substr = lineText.substring(startOffset, endOffset);
      return this.findNextBracketInText(bracketRegex, lineNumber, substr, startOffset);
    }
  }]);

  return BracketsUtils;
}();